export const PHONE_DISPLAY = "07 69 39 01 67";
export const PHONE_TEL = "tel:+33769390167";
export const EMAIL = "cozyhome.geral@gmail.com";
export const WHATSAPP_URL = "https://wa.me/33769390167";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61584347581025";
export const INSTAGRAM_URL = "https://www.instagram.com/cozyhome1500/";
export const ZONE = "Vesoul et alentours — Haute-Saône";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
